import IconButton from "@mui/material/IconButton";
import { Done } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

export default function IconButtonDone({
  onBtnClick,
  onClick,
  disabled,
  size = "large",
  color = "default",
  tooltip = "",
  sx
}) {
  return (
    <IconButton
      onClick={onBtnClick || onClick}
      disabled={disabled}
      size={size}
      color={color}
      sx={sx}
    >
      <Tooltip title={tooltip}>
        <Done fontSize="inherit" />
      </Tooltip>
    </IconButton>
  );
}
